export const PENDENTES = 'ALTERADO';

export const AGENDADOS = 'REJEITADO,AGENDADO,NOVO';

export const CANCELADOS = 'CANCELADO';

export const ENTREGUES = 'ENTREGUE';

export const TODOS = 'ALTERADO,REJEITADO,AGENDADO,NOVO,ENTREGUE,CANCELADO';


export const STATUS_OPTIONS = [
    {value: TODOS, label: 'Todos'},
    {value: AGENDADOS, label: 'Pendentes'},
    {value: ENTREGUES, label: 'Entregues'},
    {value: PENDENTES, label: 'Rejeitados'},
    {value: CANCELADOS, label: 'Cancelados'}
];
